import { get, cloneDeep } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import pagingWithFilteredResults, { pagingWithResults, presentationOptions } from '@/constants/states';
import defaultStates, { destroyStates, readStates, updateStates } from '@/constants/lifecycle';
import findResult, { findWithCodes } from '@/utils/resultsHelper';
import { PANELS, userGroupCategories, userGroupStates } from '../constants';

export const usergroupPanels = (openPanels = [PANELS.USERS]) => ({
  panels: openPanels,
});

const selectableUsers = (multiSelect = true) => ({
  multiSelect,
  selectedUser: null,
  selectedUserGroups: [],
});

const allUserGroups = (display = presentationOptions.TABLE) => ({
  all: {
    ...pagingWithFilteredResults(),
    ...userGroupStates,
    display,
    ...selectableUsers(),
  },
});

export const taskUserGroups = () => ({
  ...pagingWithResults(10000),
  ...readStates,
  selectedUserGroups: [],
  bpmn: true,
});

export const userGroupUsersGroupsState = {
  userGroups: {
    ...defaultStates,
    results: [],
    groupsToAdd: [],
    filter: '',
    search: {
      ...readStates,
      results: [],
      filter: '',
      filteredResults: [],
    },
  },
};

export const usergroupUserSearchState = () => ({
  filter: '',
  results: [],
  ...readStates,
});

export const userGroupUsersState = {
  users: {
    results: [],
    ...readStates,
    ...updateStates,
    ...destroyStates,
    toAdd: [],
  },
  userSearch: usergroupUserSearchState(),
};

export const openUserGroup = ({ code, ...rest }) => ({
  ...userGroupStates,
  code,
  isDirty: false,
  isEditing: true,
  isNew: true,
  name: '',
  description: '',
  copy: {},
  ...userGroupUsersState,
  ...usergroupPanels(),
  ...rest,
});

export const userGroupsAssign = () => ({
  users: {
    results: [],
  },
});

export const activeUserGroup = () => ({
  ...userGroupStates,
  open: false,
  code: '',
  name: '',
  description: '',
  bpmn: false,
});

export const newUserGroupProperties = (item) => {
  const copy = cloneDeep(item);
  return {
    ...copy,
    code: null,
    uuid: copy.code,
    open: true,
  };
};

const initialState = {
  activeUserGroup: activeUserGroup(),
  newUserGroupCode: uuidv4(),
  deleteUserGroupOpen: false,
  userGroups: {
    ...allUserGroups(),
    tasks: taskUserGroups(),
    deletion: { results: [] },
    open: { results: [] },
    assign: userGroupsAssign(),
  },
};

export const userGroupsResult = (selectedUserGroups) => (result) => ({
  ...userGroupUsersState,
  selected: !!selectedUserGroups.includes(result.code),
  ...result,
});

export const userGroupsStateToLoad = (state) => {
  const display = get(
    state,
    'userGroups.userGroups.all.display',
    presentationOptions.TABLE,
  );

  return {
    ...initialState,
    userGroups: {
      ...initialState.userGroups,
      ...allUserGroups(display),
    },
  };
};

export const userGroupsStateToSave = (state) => ({
  userGroups: {
    userGroups: {
      all: {
        display: state.userGroups.userGroups.all.display,
      },
    },
  },
});

export const findUserGroups = ({ userGroups }, { category }) => userGroups[category];

export const findAllUserGroups = ({ userGroups }, { items }) => {
  const codes = items.map(({ code }) => code);
  return findWithCodes(userGroups, userGroupCategories, codes);
};

export const findUserGroup = ({ userGroups }, { category, code }, attribute = 'code') => (
  findResult(userGroups, category, code, attribute)
);

export const userGroupStepNames = (steps) => Object.values(steps).map(({ name }) => name);

export default initialState;
